import { render, staticRenderFns } from "./ClientAccountChangeRequestsDetailsView.vue?vue&type=template&id=117bb336&scoped=true"
import script from "./ClientAccountChangeRequestsDetailsView.vue?vue&type=script&lang=js"
export * from "./ClientAccountChangeRequestsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./ClientAccountChangeRequestsDetailsView.vue?vue&type=style&index=0&id=117bb336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bb336",
  null
  
)

export default component.exports